import React, { useEffect, useState } from 'react';

export default function LoadScripts() {
    const [loading, setLoading] = useState(true); // State to manage the preloader visibility

    useEffect(() => {
        window.scrollTo(0, 0);
        const scripts = [
            '/assets/js/vendor/jquery.js',
            '/assets/js/vendor/waypoints.js',
            '/assets/js/bootstrap-bundle.js',
            '/assets/js/meanmenu.js',
            '/assets/js/swiper-bundle.js',
            '/assets/js/slick.js',
            '/assets/js/range-slider.js',
            '/assets/js/magnific-popup.js',
            '/assets/js/nice-select.js',
            '/assets/js/purecounter.js',
            '/assets/js/countdown.js',
            '/assets/js/wow.js',
            '/assets/js/isotope-pkgd.js',
            '/assets/js/imagesloaded-pkgd.js',
            '/assets/js/ajax-form.js',
            '/assets/js/infinite-scroll.js',
            '/assets/js/main.js',
        ];

        const loadScript = (src) => {
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = resolve;
                script.onerror = reject;
                document.body.appendChild(script);
            });
        };

        const loadScriptsSequentially = async () => {
            for (const src of scripts) {
                await loadScript(src);
            }
            setLoading(false); // Hide preloader after all scripts are loaded
        };

        loadScriptsSequentially();
    }, []);

    if (loading) {
        return (<></>
            // <div id="loading">
            //     <div id="loading-center">
            //         <div id="loading-center-absolute">
            //             {/* loading content here */}
            //             <div className="tp-preloader-content">
            //                 <div className="tp-preloader-logo">
            //                     <div className="tp-preloader-circle">
            //                         <svg width={190} height={190} viewBox="0 0 380 380" fill="none" xmlns="http://www.w3.org/2000/svg">
            //                             <circle stroke="#D9D9D9" cx={190} cy={190} r={180} strokeWidth={6} strokeLinecap="round" />
            //                             <circle stroke="red" cx={190} cy={190} r={180} strokeWidth={6} strokeLinecap="round" />
            //                         </svg>
            //                     </div>
            //                     <img src="assets/img/logo/preloader/preloader-icon.svg" alt="preloader-icon" />
            //                 </div>
            //                 <h3 className="tp-preloader-title">Shofy</h3>
            //                 <p className="tp-preloader-subtitle">Loading</p>
            //             </div>
            //         </div>
            //     </div>
            // </div>
        );
    }

    return null; // Return null when scripts are loaded
}